// export enum MarketplaceTab {
//   COLLECTABLE = 'collectables',
//   TRADE = 'trade',
// }

export const CARD_SKELETON_HEIGHT = 350;
export const CARD_SKELETON_WIDTH = 240;
export const COLLECTABLE_SKELETON_AMOUNT = 8;
export const COLLECTABLE_SKELETON_FILTERS_AMOUNT = 5;
